<template>
  <div class="status-bar">
    <div class="status-bar-container" :class="{wide: showUserBlock}">
      <img src="@/assets/img/logo.svg" class="status-bar__logo" alt="logo" />
      <div v-if="showContent" class="status-bar-content">
        <icu-icon
          v-if="showBackButton"
          class="status-bar__back-btn"
          icon-name="arrow-down"
          @click="$emit('back')"
        />
        <div class="status-bar__title">
          <div v-if="title">
            {{ title }}
          </div>
        </div>
      </div>
      <user-block v-if="showUserBlock"></user-block>
      <pc-language-switcher v-if="showUserBlock" />
      <language-switcher v-else class="status-bar__switcher" />
    </div>
    <div class="status-bar__status-ribbon" :style="{width: `${width}%`}" />
  </div>
</template>

<script>
import IcuIcon from '@/components/common/IcuIcon.vue'
import LanguageSwitcher from '@/components/common/LanguageSwitcher.vue'
import UserBlock from '@/assets/scss/components/views/RegisterPage/UserBlock'
import PcLanguageSwitcher from '@/components/common/PcLanguageSwitcher'
export default {
  name: 'StatusBar',
  components: {PcLanguageSwitcher, UserBlock, LanguageSwitcher, IcuIcon },
  props: {
    width: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ''
    },
    showBackButton: {
      type: Boolean,
      default: false
    },
    showContent: {
      type: Boolean,
      default: true,
    },
    showUserBlock: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/components/views/RegisterPage/StatusBar.scss";
.wide {
  max-width: 1178px
}
</style>
